<div class="custom-dialog {{data.modalType}}">
  <img style="padding:5px" src="assets/img/icon.png" width="110" height="60" />
  <h2 mat-dialog-title>{{data.title}}</h2>
  <mat-dialog-content>
    <p>
      {{data.message}}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button *ngIf="data.modalType === 'question'" mat-button mat-raised-button [mat-dialog-close]="false">No</button>
    <button *ngIf="data.modalType === 'question'" mat-raised-button color="warn" [mat-dialog-close]="true">Yes</button>
    <button *ngIf="data.modalType === 'info' || data.modalType === 'warn' || data.modalType === 'error'" mat-raised-button color="warn" [mat-dialog-close]="true">OK</button>
  </mat-dialog-actions>
</div>
